module.exports = __webpack_public_path__ + "static/media/recruiter.96f7deaf.svg";